import styled from "@emotion/styled";
import { FormLabel } from "@mui/material";
import { grey } from "@mui/material/colors";

export const StyledLabel = styled(FormLabel)(() => ({
  paddingBottom: "0.625rem",
  fontWeight: 600,
  color: grey[900],
}));